import * as React from 'react';

import { Button } from '@rematter/ui-web';
import { useSetAtom } from 'jotai';

import { $loadInfoFocusSignal } from '../../_state/loadsTab.state';
import { tradeRoutePaths } from '../../routes';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { useModuleLocation } from '~/shared/hooks/useModuleLocation';

type FocusSignal = 'salesOrder' | 'booking' | null;

function getFocusTarget(
  hasSalesOrderId: boolean,
  hasBookingId: boolean,
): FocusSignal {
  if (!hasSalesOrderId) return 'salesOrder';
  if (!hasBookingId) return 'booking';
  return null;
}

export interface Props {
  loadId: string;
  hasSalesOrderId: boolean;
  hasBookingId: boolean;
}

export const LoadAssignDataAction: React.FC<Props> = ({
  loadId,
  hasSalesOrderId,
  hasBookingId,
}) => {
  const t = useTranslations();

  const setFocusSignal = useSetAtom($loadInfoFocusSignal);

  const [, navigate] = useModuleLocation();

  const handleAssignData = React.useCallback(() => {
    setFocusSignal(getFocusTarget(hasSalesOrderId, hasBookingId));

    navigate(tradeRoutePaths.loadDetail, {
      params: { id: loadId },
      query: { tab: 'load-info' },
      keepSearchParams: false,
    });
  }, [loadId, navigate, setFocusSignal, hasSalesOrderId, hasBookingId]);

  return (
    <Button
      variant="outline"
      onPress={handleAssignData}
      className="@LoadAssignDataAction"
    >
      {!hasSalesOrderId
        ? t.loadStatusTransition.assignSalesOrder
        : t.loadStatusTransition.assignBooking}
    </Button>
  );
};
